/**
 * 将 CMS / PHP 常见 HTML 实体还原为字符（如 &#039; → '），供 JSON 字段展示用。
 * 浏览器内优先用 textarea，避免手写实体表不全；非浏览器环境用有限替换链。
 */
export function decodeHtmlEntities(text: string): string {
  if (!text || !text.includes('&')) return text;

  if (typeof document !== 'undefined') {
    const ta = document.createElement('textarea');
    let prev = text;
    for (let i = 0; i < 5; i++) {
      ta.innerHTML = prev;
      const next = ta.value;
      if (next === prev) break;
      prev = next;
    }
    return prev;
  }

  let out = text;
  for (let i = 0; i < 5; i++) {
    const next = out
      .replace(/&#x([\da-f]{1,6});/gi, (_, hex) => String.fromCharCode(parseInt(hex, 16)))
      .replace(/&#(\d{1,7});/g, (_, dec) => String.fromCharCode(Number(dec)))
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
    if (next === out) break;
    out = next;
  }
  return out;
}
